import { useMutation } from '@tanstack/react-query';

import { ActivityEndpoints } from '../../../../constants/endpoints/activityEndpoints.ts';
import { getAxios } from '../../../../lib/axios';
import { NewUnverifiedTravellerRequest } from '../../../../features/activities/travellers/types';
import { SelectOption } from '@invara-dev/react-base';

export function useNewUnverifiedTravellerMutation() {
  return useMutation({
    mutationFn: async (vars: {
      activityId: number | undefined;
      companyId: number;
      model: NewUnverifiedTravellerRequest;
    }) =>
      await getAxios().post<SelectOption[]>(
        ActivityEndpoints.travellers.createUnverified(vars.activityId, vars.companyId),
        vars.model
      )
  });
}
